module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_AlarmBell_16"],"path":[{"$":{"d":"M10,14a2,2,0,1,1-4,0Zm3-5c0-2.78-.91-6.22-4-6.89V1A1,1,0,1,0,7,1V2.11C3.91,2.78,3,6.22,3,9c0,1.83-1,2-1,2v2H14V11S13,10.83,13,9Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_AlarmBell_16.svg
// module id = pkoH
// module chunks = 1